<template>
    <svg class="stroke-current" width="16px" height="16px" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, 1, 0, 0)">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.672"></g><g id="SVGRepo_iconCarrier">
        <path d="M17.0001 9L10 16L7 13" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path> </g>
    </svg>
</template>
